import { render, staticRenderFns } from "./SelectStudentLevelsDialog.vue?vue&type=template&id=5c5fc37e&scoped=true"
import script from "./SelectStudentLevelsDialog.ts?vue&type=script&lang=ts&external"
export * from "./SelectStudentLevelsDialog.ts?vue&type=script&lang=ts&external"
import style0 from "./SelectStudentLevelsDialog.scss?vue&type=style&index=0&id=5c5fc37e&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5fc37e",
  null
  
)

export default component.exports